module.exports = ".error-template {\n  padding: 80px 15px;\n  text-align: center; }\n"